import { api } from '../api';

export const eventService = {
  create: (data: any, config?: any) => api.post('/events', data, config),
  update: (id: string, data: any, config?: any) => api.put(`/events/${id}`, data, config),
  get: (id: string) => api.get(`/events/${id}`),
  getById: async (id: string) => {
    const response = await api.get(`/events/${id}`);
    return response.data;
  },
  /** Busca evento por ID ou Slug (para URLs públicas) */
  getPublic: (idOrSlug: string) => api.get(`/events/public/${idOrSlug}`),
  list: (page = 1, limit = 15, filters?: { title?: string; status?: string; hasTickets?: boolean; archived?: boolean }) => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });

    if (filters?.title) {
      params.append('title', filters.title);
    }
    if (filters?.status) {
      params.append('status', filters.status);
    }
    if (filters?.hasTickets !== undefined) {
      params.append('hasTickets', filters.hasTickets.toString());
    }
    if (filters?.archived !== undefined) {
      params.append('archived', filters.archived.toString());
    }

    return api.get(`/events?${params.toString()}`);
  },
  listPerOrganizer: (page = 1, limit = 15) => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });
    return api.get(`/events/my-events?${params.toString()}`);
  },
  listForSelect: (page = 1, limit = 30, options?: { title?: string; organizer?: boolean }) => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      forSelect: 'true',
    });
    if (options?.title) {
      params.append('title', options.title);
    }
    if (options?.organizer) {
      return api.get(`/events/my-events?${params.toString()}`);
    }
    return api.get(`/events?${params.toString()}`);
  },
  remove: (id: string) => api.delete(`/events/${id}`),
  duplicate: (id: string) => api.post(`/events/${id}/duplicate`),
  promote: (id: string, title: string) => api.post(`/events/${id}/promote`, { title }),
  archive: (id: string) => api.patch(`/events/${id}/archive`),
  unarchive: (id: string) => api.patch(`/events/${id}/unarchive`),
  /** Busca vagas disponíveis do evento */
  getAvailableSlots: (id: string) => api.get(`/events/${id}/available-slots`),
};